import { useEffect } from 'modules/core/hooks/useEffect'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import { FinancialWorkspaceAvailabilities } from 'modules/finance/components/FinancialWorkspace/hooks/useFinancialWorkspaceAvailabilities'

import { NoPayrollButExpenses } from './variants/NoPayrollButExpenses'
import { NoPayrollNoExpenses } from './variants/NoPayrollNoExpenses'

interface Props {
  availabilities: FinancialWorkspaceAvailabilities
}

export const PayrollLanding = ({ availabilities }: Props) => {
  const {
    modules: { expenses },
  } = availabilities
  const missingExpensesModule = !expenses

  useEffect(() => {
    track(trackingEvents.accounting.newFinancialWorkspace.launch.landingViewed, {
      modules: missingExpensesModule ? 'noexpenses_nopayroll' : 'yesexpenses_nopayroll',
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (missingExpensesModule) {
    return <NoPayrollNoExpenses />
  }

  return <NoPayrollButExpenses />
}
